import { render, staticRenderFns } from "./comUpload.vue?vue&type=template&id=81fa3528&scoped=true&"
import script from "./comUpload.vue?vue&type=script&lang=js&"
export * from "./comUpload.vue?vue&type=script&lang=js&"
import style0 from "./comUpload.vue?vue&type=style&index=0&id=81fa3528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fa3528",
  null
  
)

export default component.exports